
import { v4 as uuidv4 } from 'uuid';
import { ChartNoAxesCombined, ClipboardType, Command, CreditCard, Gift, Grid2x2Check, HandHeart, HeartHandshake, IndianRupee, LayoutDashboard, MessageCircleQuestion } from 'lucide-react';
import { lazy } from 'react';

const routes = [
    {
        key: uuidv4(),
        label: "Analytics",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/dashboard",
        icons: <LayoutDashboard size={20} />,
        label: "Dashboard",
        type: "route",
    },
    {
        key: uuidv4(),
        path: "/dashboard/payment-history",
        icons: <CreditCard size={20} />,
        label: "Transactions ",
        type: "route",
    },
    {
        key: uuidv4(),
        label: "Management",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/dashboard/module",
        icons: <Command size={20} />,
        label: "Module List",
        type: "route",
    },
    {
        key: uuidv4(),
        path: "/dashboard/daycare",
        icons: <HandHeart size={20} />,
        label: "Daycare List",
        type: "route",
    },
    
    {
        key: uuidv4(),
        path: "/dashboard/subscription",
        icons: <Gift size={20} />,
        label: "Subscription Plan",
        type: "route",
    },
    {
        key: uuidv4(),
        path: "/dashboard/relation",
        icons: <HeartHandshake size={20} />,
        label: "Relation List",
        type: "route",
    },
    {
        key: uuidv4(),
        path: "/dashboard/category",
        icons: <Grid2x2Check size={20} />,
        label: "Category List",
        type: "route",
    },
     {
        key: uuidv4(),
        path: "/dashboard/cms",
        icons: <ClipboardType size={20} />,
        label: "CMS ",
        type: "route",
    },
    {
        key: uuidv4(),
        label: "Support",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/dashboard/enquiry",
        icons: <MessageCircleQuestion size={20} />,
        label: "Send Enquiry",
        type: "route",
    },
]

export default routes;